export default __webpack_public_path__ + "static/media/bitwallet-swissMarkets-light.6e18b058.svg";